import { useSelector } from 'react-redux'
import { COUNTRY } from '@qflow/constants'

import { textValueByCountry, wasteFieldsByCountry } from 'portal/lib/constants'
import { imperial } from 'portal/lib/functions'

export const useCountryDrivenValues = () => {
  const projectCountry = useSelector(
    (state: any) => state.projectDetails.modules?.country
  )

  const country =
    Object.keys(COUNTRY).find(
      k => COUNTRY[k as keyof typeof COUNTRY] === projectCountry
    ) || 'UK'

  const isImperial = imperial(projectCountry)

  const text = {}
  Object.keys(textValueByCountry).forEach(key => {
    text[key] =
      textValueByCountry[key][country] || textValueByCountry[key]['UK']
  })

  const wasteFields = {}
  Object.keys(wasteFieldsByCountry).forEach(key => {
    wasteFields[key] =
      country in wasteFieldsByCountry[key]
        ? wasteFieldsByCountry[key][country]
        : wasteFieldsByCountry[key]['UK']
  })

  return { isImperial, text, wasteFields }
}
